'use strict';

export default function comparisonClear() {
    $(document).on('click', '.clear-comparison', function (e) {
        e.preventDefault();
        let d = new Date();
        let url = '/inner/offices/ajax/clearcomparator/t/'+ d.getTime();

        // remove alert
        let $alertHld = $('.js-alerts-hld'),
            $alert = $('.js-alert[data-type="comparison"]');

        $alert.remove();
        $alertHld.append($([
            `<div class="alert alert-error t-a-c" data-type="comparison">`,
            `</div>`].join('')));

        // clear boxes on list
        $('.rmb-objects-list .rmb-object.rmb-object-list-item.js-search-object.active').removeClass('active');

        // uncheck compare button on details
        $('.btn-group .js-object-action.active').attr('data-state', 'false').removeClass('active');

        var href = $(this).attr('href');

        $.getJSON( url, function(obj){
            if (href && href !== '#') {
                window.location.href = href;
            }
        });
    });
}
